import React from 'react';
import { ModuleProps } from 'types';
import getRoutes from './routes';
import RouteModuleFactory from '../@layout/Router/RouteModuleFactory';
import PrintScreenContainer from './PrintScreenContainer';

const routes = getRoutes();

const PrintScreenModule: React.FC<ModuleProps> = moduleProps => {
  return (
    <PrintScreenContainer {...moduleProps}>
      <RouteModuleFactory redirectPath={'/dashboard'} routes={routes} {...moduleProps} />
    </PrintScreenContainer>
  );
};

export default PrintScreenModule;
